import React from "react";
import logo from "assests/logo.png";
import { Link } from "react-router-dom";
const Logo = ({ isSticky, isDown }) => {
  return (
    <Link to={"/"}>
      <img
        className={`transition ease-in duration-300  ${
          isSticky || isDown ? "w-28" : "w-32 lg:w-40"
        }`}
        src={logo}
        alt=""
      />
    </Link>
  );
};

export default Logo;
